import { render } from "./VZFilter.vue?vue&type=template&id=46170b8b&ts=true"
import script from "./VZFilter.vue?vue&type=script&lang=ts"
export * from "./VZFilter.vue?vue&type=script&lang=ts"

import "./VZFilter.vue?vue&type=style&index=0&id=46170b8b&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__